import { Flex } from "@mantine/core"
import CommentsMenu from "../Comment/CommentsMenu"


const CustomerActions = () => {
  return (
    <Flex
      justify="space-between"
      px="35px"
      pb="20px"
      h="64px"
      sx={{ borderBottom: "1px solid #D8D8DB" }}
      align="center"
    >
      
      <CommentsMenu componentType="customer"/>
    </Flex>
  )
}

export default CustomerActions